import { SCode, StatusHistoryConditionType } from '../constants';
import { SelectedTimezoneModel } from '../../store/models/local-date.model';

export enum StatusHistoryOriginEnum {
  ShipsGo = 'SHIPSGO',
  ShippeoETA = 'SHIPPEO_ETA',
  Iftsta = 'IFTSTA',
  IftstaManual = 'IFTSTA_MANUAL',
  GeoFence = 'GEO_FENCE',
  Ml = 'ML',
}

export class StatusHistoryDates {
  receivedDateTime: DateWithTimezones | null = null;
  estimatedDateTime: DateWithTimezones | null = null;
  intrackEstimatedDateTime: DateWithTimezones | null = null;
  shipsGoEstimatedDateTime: DateWithTimezones | null = null;
  actualDateTime: DateWithTimezones | null = null;
  origin: StatusHistoryOriginEnum;
}

export class DateWithTimezones {
  timestamp: number;
  profileTimezoneData: SelectedTimezoneModel;
  localTimezoneData: SelectedTimezoneModel;
}

export class StatusHistoryChainModel {
  statusCode: SCode;
  statusCodeDescription: string;
  condition: StatusHistoryConditionType;
  dates: StatusHistoryDates[];
}
